import React from 'react';
import ListEmptyView from 'design-system/ListEmptyView';
const strings = {
    title: 'Oh snap!\nDidn’t find what you were looking for?',
    secclTitle: 'No results found',
    subtitle: 'We’re expanding the list of securities over the\xa0coming months. Stay tuned for new stocks coming soon!',
    secclSubtitle: 'We have not found the fund you were looking for',
};
const NoSearchResults = ({ broker }) => (<ListEmptyView alt happy onCard title={broker === 'seccl' ? strings.secclTitle : strings.title} subTitle={broker === 'seccl' ? strings.secclSubtitle : strings.subtitle}/>);
export default NoSearchResults;
